export default __webpack_public_path__ + "static/media/twitter.740c588f.svg";